var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshare = function SvgScreenshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.828 17.672h4.875v1.539h-.07a.509.509 0 0 0-.508.516c0 .28.227.507.508.507h4.726a.514.514 0 0 0 .516-.507.515.515 0 0 0-.516-.516h-.07v-1.54h4.875c.945 0 1.516-.57 1.516-1.515V7.117c0-.945-.57-1.515-1.516-1.515H4.828c-.937 0-1.516.57-1.516 1.515v9.04c0 .945.579 1.515 1.516 1.515Zm-.156-3.14c-.234 0-.336-.095-.336-.337V7.141c0-.32.195-.524.516-.524H19.14c.32 0 .523.203.523.524v7.054c0 .242-.11.336-.344.336H4.672Z"
  })));
};
export default SvgScreenshare;